import React, { lazy } from 'react';
const HelpDashboard = lazy(() => import('../containers/Help/HelpDashboard'));
function HelpRouts() {
    return React.createElement(HelpDashboard, null);
}
export default HelpRouts;
